/**
 * Parses a price string and returns the numeric value.
 *
 * @param {string} priceStr - The price string to parse.
 * @returns {number} The numeric value of the price.
 */

export default function parsePrice(priceStr) {
  //  Remove currency symbol and commas, then parse as a number
  const price = parseFloat(priceStr?.replace(/[$,]/g, ''));
  return price;
};